<app-header [showSlider]="false" [navLight]="false"></app-header>
<br>
<br>
<br>
<div class="container">
    <h4 class="mt-5 text-center fs-2">Our Team</h4>
</div>
<!-- <div class="container">
    <div class="row">
        <div class="col-2"></div>
        <div class="col-8">

            <div class="row">
                <div [id]="t.id" [attr.imagename]="t.imagename" [attr.cellposition]="i+1"
                    class="cell col-6 col-md-3 d-flex justify-content-center flex-column align-items-center"
                    *ngFor="let t of teamData;let i =index">
                   
                    <img #imgRef class="arrow team-img" alt="">
                    <br>
                 
                    <div class="text-center fs-5 text-primary">{{t.name}}</div>
                    <div class="text-center fs-6">{{t.designation}}</div>
                </div>
            </div>

        </div>
        <div class="col-2"></div>
    </div>

</div> -->






<!-- <div class="container">
    <div class="row">
        <div class="col-2"></div>
        <div class="col-8">

            <div class="row">
                <div [attr.image]="t.image"
                    class="cell col-6 col-md-3 d-flex justify-content-center flex-column align-items-center"
                    *ngFor="let t of teamData;let i =index">

                    <img class="rounded-circle img-fluid w-60 d-block mx-auto " alt="" [src]="t.image">
                    <br>

                    <div class="text-center fs-5 text-primary">{{t.name}}</div>
                    <div class="text-center fs-6">{{t.designation}}</div>
                </div>
            </div>

        </div>
        <div class="col-2"></div>
    </div>

</div> -->





<br>
<div class="container">
    <div class="row justify-content-center">
        <div class="col-12 col-md-10">

            <div class="row justify-content-center">
                <div class="col-6 col-md-3 d-flex flex-column align-items-center mb-4"
                    *ngFor="let t of team.responses;let i = index">
                    <img class="rounded-circle img-fluid" [src]="t.response.image_upload_1752571588920_83141.url"
                        style="width: 150px; height: 150px; object-fit: cover;" />
                    <div class="text-center mt-3 fs-5 text-primary">{{ t.response.text_1752571598222_76621 }}</div>
                    <div class="text-center fs-6">{{ t.response.text_1752572329538_6435 }}</div>
                </div>
            </div>

        </div>
    </div>
</div>



<app-footer></app-footer>